if(typeof EARCUT === 'undefined') {var e = new Error("Cannot find module 'EARCUT'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = EARCUT;